
import configureStore from './configure';
import InitialState from './InitialState';
import { persistStore } from 'redux-persist';

const store = configureStore(InitialState);
const persistor = persistStore(store);

export { store, persistor };